import { HFlow } from 'bold-ui'
import { RadioGroupField, RadioGroupFieldProps } from 'components/form'
import { RequiredLabel } from 'components/form/final-form/RequiredLabel/RequiredLabel'
import { InfoIcon } from 'components/InfoIcon'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

const options = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM, label: 'Sim' },
  {
    value: RastreioCancerPerguntaOpcaoEnum.NAO_NAO_SABE_NAO_LEMBRA_NAO_ESTA_NA_MENOPAUSA,
    label: 'Não/Não sabe/Não lembra/Não está na menopausa',
  },
]

export function SangramentoMenopausaRadioField(
  props: Readonly<Omit<RadioGroupFieldProps<RastreioCancerPerguntaOpcaoEnum>, 'options'>>
) {
  return (
    <RadioGroupField
      {...props}
      label={
        <HFlow hSpacing={0.1}>
          <RequiredLabel inline fontWeight='bold' label='Tem ou teve algum sangramento após a menopausa?' />
          <InfoIcon
            icon='infoCircleFilled'
            text='Não considerar o(s) sangramento(s) na vigência de reposição hormonal'
          ></InfoIcon>
        </HFlow>
      }
      options={options}
    />
  )
}
